import React from 'react';
import { ContractInfo } from 'api/types/httpsTypes/contracts';
import { NotificationDex } from '../components/alerts/notification';
import { LoadingComponent } from '../terminal/components/loadingComponent';
import { useUserState } from 'modules/user/UserContext';

interface Props {
  children: React.ReactNode;
  contract: ContractInfo | undefined;
  isLoadingTemplates?: boolean;
  isLoading: boolean;
  error: any;
}

export function TerminalPageMobile({
  contract,
  children,
  isLoading,
  error,
  isLoadingTemplates,
}: Props) {
  const { user } = useUserState();

  if (isLoading || (user && isLoadingTemplates)) {
    return <LoadingComponent />;
  }

  if (error || !contract) {
    return (
      <NotificationDex
        errorMessage={error}
        className="xxs:mx-2 lg:mx-0"
        type="error"
      >
        Could not load contract data.
      </NotificationDex>
    );
  }

  return <div className="space-y-0 pb-16 lg:pb-0 lg:space-y-1">{children}</div>;
}
